import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9110c470"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-files-widget__title" }
const _hoisted_2 = { class: "loading-files-widget__controls" }
const _hoisted_3 = {
  key: 0,
  class: "loading-files-widget__progress"
}
const _hoisted_4 = { class: "loading-files-widget__progress-line" }
const _hoisted_5 = { class: "loading-files-widget__progress-percent" }
const _hoisted_6 = { class: "loading-files-widget__files" }

import { computed, ref, watch } from "vue";
import { FileManager, FileUploadStatusEnum } from "tir-pm-file-upload-manager";
import {
  FilePreviewAccessEnum,
  FilePreviewVariantEnum,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmFilePreview,
  TirPmScrollbar,
} from "tir-components";
import { ChevronDownIcon, CrossCompactIcon } from "tir-style-system/icons/outline";
import { LoadingFileModel } from "./models";

/**Список загружаемых файлов */
const fileHeight = 34 / 16; // 34px = высота файла + отступ, переведено в rem

export default /*#__PURE__*/_defineComponent({
  __name: 'loading-files-widget',
  setup(__props) {

const files = computed(() => {
  return FileManager.ActiveUploads.value.reduce((acc, file) => {
    if (
      (file.isFileModel() || file.isVideoModel()) &&
      file.Status === FileUploadStatusEnum.Uploading &&
      file.Progress !== undefined
    ) {
      return [
        ...acc,
        new LoadingFileModel({
          FileId: file.FileId,
          Url: file.Url,
          Name: file.Name,
          Size: file.Size,
          Progress: file.Progress,
          Accesses: file.IsSendingLastChunk ? [] : [FilePreviewAccessEnum.Remove],
        }),
      ];
    }
    return acc;
  }, new Array<LoadingFileModel>());
});

const calculateTotalProgressByFileSize = (files: LoadingFileModel[]): number => {
  let totalWeightedProgress = 0;
  let totalSize = 0;

  files.forEach((file) => {
    totalWeightedProgress += file.Progress * file.Size;
    totalSize += file.Size;
  });

  // Защита от деления на ноль, если размеры файлов равны нулю
  if (totalSize === 0) return 0;

  // Вычисляем общий прогресс как взвешенное среднее
  return totalWeightedProgress / totalSize;
};

const generalProgress = computed(() => calculateTotalProgressByFileSize(files.value).toFixed(0));

const dynamicHeight = computed(() => {
  return `${Math.min((files.value.length + 20) * fileHeight + 0.875, 9)}rem`;
});

const title = computed(() => `Загружается файлов: ${files.value.length}`);

/**Видимо */
const isVisible = ref(false);

/**Свернуто */
const isCollapced = ref(true);
/**Переключиить флаг isCollapced */
const toggleCollapced = () => (isCollapced.value = !isCollapced.value);
watch(
  () => isVisible.value,
  () => {
    if (!isVisible.value) isCollapced.value = true;
  },
);
/** Следим за изменением списка файлов */
watch(
  () => files.value.length,
  (newFileCount, oldFileCount) => {
    if (!newFileCount) {
      isVisible.value = false;
      isCollapced.value = false;
    }
    // Если количество файлов увеличилось, значит добавлен новый файл
    else if (newFileCount > oldFileCount) {
      isVisible.value = true;
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "visible" }, {
      default: _withCtx(() => [
        (isVisible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['loading-files-widget', { 'is-collapced': isCollapced.value }])
            }, [
              _createElementVNode("div", {
                class: "loading-files-widget__header",
                onClick: toggleCollapced
              }, [
                _createElementVNode("span", _hoisted_1, _toDisplayString(title.value), 1),
                _createElementVNode("div", _hoisted_2, [
                  (isCollapced.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", {
                            class: "loading-files-widget__progress-fill-line",
                            style: _normalizeStyle({ width: `${generalProgress.value}%` })
                          }, null, 4)
                        ]),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(generalProgress.value) + "%", 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(TirPmButton), {
                    size: _unref(TirPmButtonSizeEnum).Small,
                    variant: _unref(TirPmButtonVariantEnum).LinkState
                  }, {
                    leftSlot: _withCtx(() => [
                      _createVNode(_unref(ChevronDownIcon), { class: "loading-files-widget__chevron-icon" })
                    ]),
                    _: 1
                  }, 8, ["size", "variant"]),
                  _createVNode(_unref(TirPmButton), {
                    size: _unref(TirPmButtonSizeEnum).Small,
                    variant: _unref(TirPmButtonVariantEnum).LinkState,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isVisible.value = false), ["stop"]))
                  }, {
                    leftSlot: _withCtx(() => [
                      _createVNode(_unref(CrossCompactIcon))
                    ]),
                    _: 1
                  }, 8, ["size", "variant"])
                ])
              ]),
              _createElementVNode("div", {
                class: "loading-files-widget__main",
                style: _normalizeStyle({ maxHeight: isCollapced.value ? '0' : dynamicHeight.value })
              }, [
                _createVNode(_unref(TirPmScrollbar), {
                  style: _normalizeStyle({ maxHeight: dynamicHeight.value })
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file) => {
                        return (_openBlock(), _createBlock(_unref(TirPmFilePreview), {
                          file: file,
                          variant: _unref(FilePreviewVariantEnum).Inline,
                          "no-media-variant": _unref(FilePreviewVariantEnum).Inline,
                          key: file.FileId,
                          onOnClickDelete: ($event: any) => (_unref(FileManager).cancel({ FileId: file.FileId }))
                        }, null, 8, ["file", "variant", "no-media-variant", "onOnClickDelete"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["style"])
              ], 4)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})